import * as regras from '@/api/regras'

import { convertSelectRegra } from '../../../service/collection'

const state = {
  regrasMinimo: [],
  list: [],
  filtros: { page: 1 },
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDel: false,
  listaSelect: []
}

const mutations = {
  SETREGRAS (state, payload) {
    state.list = payload.list
  },
  LISTREGRASMINIMO (state, payload) {
    state.regrasMinimo = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  HIDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDel = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFDEL (state) {
    state.modalConfDel = !state.modalConfDel
  },
  SETREGRASSELECT (state, payload) {
    state.listaSelect = convertSelectRegra(payload.list)
  }
}

const actions = {
  async get ({ commit }, payload) {
    let data = await regras.get(payload)
    return data
  },
  async getRegras ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await regras.getRegras(payload)
    commit('SETREGRAS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getRegrasFiltro ({ commit, dispatch }) {
    let data = await regras.getRegras(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETREGRAS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async getGerais ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let envelope = await regras.getGerais(payload)
    let data = envelope.instancia
    commit('SETREGRAS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getGeraisFiltro ({ commit, dispatch }) {
    let envelope = await regras.getGerais(state.filtros)
    let data = envelope.instancia
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETREGRAS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getGerais', state.filtros)
  },
  async add ({ commit }, payload) {
    return regras.add(payload)
  },
  async edit ({ commit }, payload) {
    return regras.edit(payload)
  },
  async statusGerais ({ commit }, payload) {
    return regras.editStatusGerais(payload)
  },
  hideModal: function ({ commit }) {
    commit('HIDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfDel: function ({ commit }) {
    commit('MODALCONFDEL')
  },
  async listRegras ({ commit }, payload) {
    let dados = await regras.listRegrasMinimo()
    commit('LISTREGRASMINIMO', dados)
  },
  async geRegrasSelect ({ commit }) {
    let data = await regras.getRegrasSelect()
    commit('SETREGRASSELECT', data)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/regras.js